<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="indigo"
        class="lead-bottom-control-panel__btn call-controll__btn ml-2 mt-1 mb-1 white--text"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon color="white">mdi-phone-forward</v-icon>
        <span
          class="lead-bottom-control-panel__item-text call-controll__item-text"
          >second</span
        >
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Dialpad</span>
      </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12">
            <v-text-field
              large
              v-model="number"
              label="Phone number"
              v-mask="'(###)###-####'"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="6" lg="6" class="center-buttons">
            <v-btn
              large
              color="red darken-1"
              :disabled="!secondParticipiant"
              class="white--text"
              @click="hangUp"
              >Hang up</v-btn
            >
          </v-col>
          <v-col cols="12" md="6" sm="6" lg="6" class="center-buttons">
            <v-btn
              large
              :disabled="secondParticipiant"
              color="green darken-1"
              class="white--text"
              @click="dial"
              >Dial</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="open = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CallSecondParticipiant",
  props: ["lead_id"],
  mounted() {
    this.sockets.subscribe("SET_SECOND_PARTICIPIANT_PARAMS", () => {});
  },
  data() {
    return {
      open: false,
      number: null,
    };
  },
  methods: {
    ...mapMutations({
      SET_SECOND_PARTICIPIANT: "conference/SET_SECOND_PARTICIPIANT",
    }),
    dial() {
      let formatedNumber = "+1" + this.number.replace(/[^\d]/g, "");

      this.$axios
        .post("/call/conference/add-participiant", {
          number: formatedNumber,
          lead_id: this.confParams.conferenceSid,
          user_id: this.user.id
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    hangUp() {
      this.$axios
        .post("/call/conference/remove-participiant", {
          conferenceSid: this.secondParticipiantParams.conferenceSid,
          callSid: this.secondParticipiantParams.callSid,
          user_id: this.user.id
        })
        .catch((err) => {
          console.log(err);
        });
      this.SET_SECOND_PARTICIPIANT(false);
    },
  },
  computed: {
    ...mapGetters({
      secondParticipiantParams: "conference/secondParticipiantParams",
      secondParticipiant: "conference/secondParticipiant",
      confParams: "twilio/confParams",
      user: "auth/user"
    }),
  },
};
</script>

<style>
.center-buttons {
  display: flex;
  justify-content: center;
}
.dial-pad-btn {
  font-size: 20px !important;
}
</style>